export default [
    '/logo/pafcpic.png',
    '/logo/papsi-mobile.jpg',
    '/logo/papsi-navbar-sm.png',
    '/ad/ga25_banner_sm.jpg',
    '/misc/contact-us-sm.jpg',
    '/misc/papsi-ho.jpg',
    '/page-not-found.jpg',
    '/loader/spinner.gif',
];